import Vue from 'vue'

import Cookies from 'js-cookie'
import '@/styles/iconfont.css'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters

import permission from '@/directive/permission' // 权限判断指令
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}

if (self != top) {
  window.switchIframeForceFullScreenStatus = function (val) {
    window.parent.postMessage({
        isIframeForceFullScreen: val,
      },
      '*'
    );
  };

  function addUpDialog() {
    let num = 0;
    for (let i = 0; i < document.getElementsByClassName('el-dialog__wrapper').length; i++) {
      console.log(document.getElementsByClassName('el-dialog__wrapper')[i], document.getElementsByClassName('el-dialog__wrapper')[i].style.display)
      if (document.getElementsByClassName('el-dialog__wrapper')[i].style.display != 'none') {
        num += 1
      }
    }
    for (let i = 0; i < document.getElementsByClassName('el-drawer__wrapper').length; i++) {
      console.log(document.getElementsByClassName('el-drawer__wrapper')[i], document.getElementsByClassName('el-drawer__wrapper')[i].style.display)
      if (document.getElementsByClassName('el-drawer__wrapper')[i].style.display != 'none') {
        num += 1
      }
    }
    if (num > 1) return true
    return false
  }
  Element.Dialog.watch.visible = function (val) {
    if (!val) {
      if (addUpDialog()) return
    }
    switchIframeForceFullScreenStatus(val)
  }
  Element.Drawer.watch.visible = function (val) {
    if (!val) {
      if (addUpDialog()) return
    }
    switchIframeForceFullScreenStatus(val)
  }
}

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
  // ,locale: enLang // 如果使用中文，无需设置，请删除
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.directive('permission', permission)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
